import CountryTable from "./countryTable";
import CurrencyTable from "./currencyTable";
import CompanyTypeTable from "./companyTypeTable";
import RecognizedExchangesTable from "./recognizedExchangeTable";
import RegulatoryBodyTable from "./regulatoryBodyTable";
import SubscriptionTable from "./subscriptionTable";
import ToolTipTable from "./ToolTipTable"
const RenderTable = ({table}) => {
    if (!table) return null;
    else if (table === "Country") {
        return <CountryTable />
    }
    else if (table === "Currency") {
        return <CurrencyTable />
    }
    else if (table === "CompanyType") {
        return <CompanyTypeTable />
    }
    else if (table === "RecognizedExchanges") {
        return <RecognizedExchangesTable />
    }
    else if (table === "RegulatoryBodies") {
        return <RegulatoryBodyTable />
    }
    else if (table === "SubscriptionPlan") {
        return <SubscriptionTable />
    }
    else if (table === "Tooltips") {
        return <ToolTipTable />
    }
    else {
        return null;
    }
}

export default RenderTable;